import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  icon: {
    display: 'inline-block',
    marginRight: '.3rem',
    fontSize: '.75rem',
    verticalAlign: 'middle',
    marginTop: '2px',
  },

  iconNoMargin: {
    marginRight: 0,
  },

  annotationStatus: {
    justifyContent: 'space-between',
  },

  valid: {
    color: '#92c591',
  },

  invalid: {
    color: '#e6dda5',
  },

  empty: {
    color: t.red03,
  },
}))

export default useStyles
